import React from 'react';
import LicenseSettings from './license-settings.jsx';
import LibraryUpdate from './library-update.jsx';
import AdvancedSettings from './advanced-settings.jsx';
const { Fragment } = wp.element;
const { __ } = wp.i18n;
const { PanelBody } = wp.components;

export default class Settings extends React.Component {
	render() {
		return (
			<Fragment>
				<PanelBody
					title={ __( 'Premium Users' ) }
					initialOpen={ ! this.props.premiumUser }
					className={ 'dsgn-settings__license' }
				>
					<Fragment>
						<LicenseSettings
							premiumUser={ this.props.premiumUser }
							onPremiumUserChange={ this.props.onPremiumUserChange }
						/>
					</Fragment>
				</PanelBody>
				<LibraryUpdate
					premiumUser={ this.props.premiumUser }
					importedPremium={ this.props.importedPremium }
					importedBasic={ this.props.importedBasic }
					importThumbnails={ this.props.importThumbnails }
					importing={ this.props.importing }
				/>
				<AdvancedSettings
					deleteLibrary={ this.props.deleteLibrary }
					designsCount={ this.props.designsCount }
				/>
			</Fragment>
		);
	}
}

// export default Designs



// WEBPACK FOOTER //
// ./src/settings.jsx